import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { img } from '../../../config';
import { drawP } from './functions';

const useStyles = makeStyles(theme => ({
  intro: {
    '& h3': {
      textAlign: 'center',
      color: theme.palette.primary.main,
    },
    '& em': {
      fontStyle: 'normal',
      color: theme.palette.secondary.main,
    },
    '& i': {
      fontStyle: 'italic',
    },
    '& p': {
      verticalAlign: 'middle',
      margin: '0.5em 0',
      textAlign: 'center',
    },
    '& svg': {
      verticalAlign: 'middle',
      margin: '0 0.25em',
      color: theme.palette.primary.main, 
    },
  },
  introImg: {
    textAlign: 'center',
    '& img': {
      maxWidth: 150,
    },
  },
  introAction: {
    textAlign: 'center',
    paddingTop: 20,
    '& button': {
      margin: 5,
    },
  },
  '@media(max-width: 850px)': {

  }
}));


function Intro(props) {
  const classes = useStyles();
  const exercise = props.data[props.state.idx];

  return (
    <div className={classes.intro}>
      <p className={classes.introImg}><img src={img('brain-lens.jpg')} alt='' /></p>
      <h3>{exercise.title}</h3>
      {exercise.description.map(drawP)}
      <p className={classes.introAction}>
        <Button variant="outlined" color="secondary" onClick={() => props.setState({type: 'menu'})}>Menu</Button>
        <Button variant="outlined" color="primary" onClick={props.start}>Start</Button>
      </p>
    </div>
  );
}

export default Intro;